import { render, staticRenderFns } from "./KampaneList.vue?vue&type=template&id=fc01431c&"
import script from "./KampaneList.vue?vue&type=script&lang=ts&"
export * from "./KampaneList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports